export const init = () => {
  // TRACKER PRODUCT PAGE BACK IN STOCK

  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.product.backInStock
  );
  const sep = AnalyticsConstants.separatorST;

  const productName = tc_vars.product_label_displayed;
  const productPrice = tc_vars.product_currentprice_ati;
  const productId = tc_vars.product_id_model;

  // ProductUnavailableView
  const productUnavailableView = new AnalyticsClickEvent(
    'ProductUnavailableView',
    tracker.defaultEvent()
  );
  productUnavailableView.options.action = 'ProductUnavailableView';
  productUnavailableView.domContainer = '.stock-notification__invite';
  productUnavailableView.domElement = '.stock-notification__invite-toggler';
  productUnavailableView.getLabel = () => `${productName} ${sep} ${productId}`;
  productUnavailableView.getValue = () => productPrice;
  tracker.addEvent(productUnavailableView);

  //Send virtual page on display

  const targetNode = document.querySelector('.stock-notification-modal');
  if (targetNode) {
    const config = { attributes: true, childList: true, subtree: true };

    const callback = mutationsList => {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'childList' &&
          mutation.target ===
            document.querySelector('.stock-notification__entry-title')
        ) {
          CUBE.Analytics.sendPageView(
            `Unavailable product subscribe /layer/unavailable-product/${productId}`
          );
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  // ProductUnavailableSubscribe
  const productAvailableSubscription = new AnalyticsClickEvent(
    'ProductUnavailableSubscribe',
    tracker.defaultEvent()
  );
  productAvailableSubscription.options.action = 'ProductUnavailableSubscribe';
  productAvailableSubscription.domElement = '#back-in-stock-submit';
  productAvailableSubscription.options.label = `${productName} ${sep} ${productId}`;
  productAvailableSubscription.options.value = productPrice;
  tracker.addEvent(productAvailableSubscription);

  // VIRTUAL PAGE - BACK IN STOCK
  const backInStockVirtualDetail = new AnalyticsEvent(
    'backInStockVirtualDetail',
    tracker.defaultEvent()
  );
  tracker.addEvent(backInStockVirtualDetail);

  CUBE.Analytics.trackers.add(tracker);
  // TODO: need a rewrite for ES6 version
  CUBE.Analytics.trackers.init(
    AnalyticsConstants.trackers.product.backInStock.name
  );
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/back-in-stock.js